Menu = {

    el:{},
    mainMenu:{},
    isMobile:false,

    init: function(){
        this.el = $('.topheader');

        this.MainMenu.init();
        this.Button.init();
        this.Plus.init();
        // this.Dropdown.init();
        Menu.resize();
    },

    resize: function(){
        Menu.isMobile = window.innerWidth > 980 ? false : true;

        if (Menu.isMobile){
            Menu.MainMenu.el.addClass('hidden');
            Menu.Button.el.removeClass('openned');
        } else {
            Menu.MainMenu.el.removeClass('hidden hide show');
        }
    },

    MainMenu: {
        isVisible:false,
        el:{},

        init: function(){
            this.el = Menu.el.find('.navigation')
            this.Item.init();
        },

        show: function(){
             this.el.addClass('show').removeClass('hide hidden');
             Menu.el.addClass('openned');
             this.isVisible = true;
        },

        hide: function(){
            this.el.addClass('hide').removeClass('show');
            Menu.el.removeClass('openned');
            this.isVisible = false;
            setTimeout( function(){
               Menu.MainMenu.el.addClass('hidden');
            },300)

            Menu.Button.el.removeClass('openned');
        },

        Item: {
            init: function(){
                Menu.MainMenu.el.find('a').click(function(event) {
                    if(!Menu.MainMenu.isVisible) return;
                    Menu.MainMenu.hide();
                });
            }
        }
    },

    Button: {
        el:{},

        init: function(){
            this.el = Menu.el.find('.mobile-button');
            this.bind();
        },

        bind: function(){

            this.el.unbind('click')
             .click(function(event) {
                 event.preventDefault();

                 if ($(this).is('.openned')){
                    Menu.MainMenu.hide();
                    $(this).removeClass('openned');
                 } else {
                    Menu.MainMenu.show();
                    $(this).addClass('openned');
                    
                    $(".search-field").removeClass("opened");
                    $(".search-field").fadeOut("fast");
                    $(".close-search").fadeOut("fast", function() {
                        $(".open-search").fadeIn();
                    });
                 }
             });
         }
    },

    Plus: {
         el:{},

        init: function(){

            this.el =  Menu.el.find('nav .m-icon');
            this.bind();
        },

        bind: function(){

            this.el.unbind('click')
             .click(function(event) {
                 event.preventDefault();
                 event.stopPropagation();

                var submenu = $(this).closest('a').next('.dropdown');

                 if (!$(this).is('.openned')){
                    Menu.el.find('.m-icon.openned').removeClass('openned');
                    Menu.el.find('.dropdown.openned').removeClass('openned').slideUp(300);
                    submenu.addClass('openned').slideDown(300);
                    $(this).addClass('openned');
                 } else {
                    submenu.removeClass('openned').slideUp(300);
                    $(this).removeClass('openned');
                    
                 }

                
             });
         }
    },

    Dropdown: {

        init: function(){

            var menuItem = Menu.el.find('nav .hasChildren');

            menuItem.unbind('mouseover')
            .mouseover(function(event) {
                if(Menu.isMobile) return;
                $(this).find('.dropdown').slideDown(300);
            })
            .unbind('mouseleave')
            .mouseleave(function(event) {
                if(Menu.isMobile) return;
                $(this).find('.dropdown').stop().slideUp(300);
            })

        }
    }

}